import { get_storageForders } from 'global/storage/storageFolders'
import React, { useCallback, useContext } from 'react'
import { ParentContext } from '../ParentContext';
import { getAllImagesInPath } from 'global/storage/storageHelpers';

export const useFileManagement = ({ setPropUrls, handleFinished, setUpdating }) => {

  const parentContext = useContext(ParentContext);
  const { states, fns, handlers, fn_cls } = parentContext ?? {}
  const { app_state, eventInfo_state, currentSettings_state, storage_state, paps_state } = states
  const { pathViews } = paps_state
  const { app_prods } = app_state ?? {}
  const { prodStorage } = app_prods ?? {}

  const handleGet_prodStorage = useCallback(async () => {
    const cbs = (res) => setPropUrls(res)
    const cb = (res) => {
      const { folderItems } = res
      const { manifests } = folderItems ?? {}
      if (manifests?.fullPath) {
        getAllImagesInPath(prodStorage, manifests.fullPath, cbs)
      }
      // 
    }
    get_storageForders(prodStorage, pathViews, {}, cb)
  }, [])

  const handleUpdate_globalUrls = useCallback(async () => {
    const cb = (res) => handleFinished(res)
    setUpdating(true)
    await fn_cls.syncEventImages(pathViews, cb);
  }, []);

  const handleUpdate_profileGlobalUrls = useCallback(async () => {
    const cb = (res) => handleFinished(res)
    setUpdating(true)
    await fn_cls.renameStorageImages(pathViews, cb, true, true)
  }, []);

  const handleUpdate_updateImageThumbnails = useCallback(async () => {
    const cb = (res) => handleFinished(res)
    setUpdating(true)
    // pathViews, handleFinished, testOnly, urlsOnly
    await fn_cls.updateImageThumbnails(pathViews, cb)
  }, []);

  const handleUpdate_organizeEventImages = useCallback(async () => {
    const cb = (res) => handleFinished(res)
    setUpdating(true)
    await fn_cls.organizeEventImages(pathViews, cb)
  }, []);

  const handleUpdate_renameStorageImages = useCallback(async () => {
    const cb = (res) => handleFinished(res)
    setUpdating(true)
    await fn_cls.renameStorageImages(pathViews, cb)
  }, []);

  const handleUpdate_testRenameStorageImages = useCallback(async () => {
    const cb = (res) => handleFinished(res)
    setUpdating(true)
    await fn_cls.renameStorageImages(pathViews, cb, true)
  }, []);

  const handleUpdate_moveFolders = useCallback(async () => {
    const cb = (res) => handleFinished(false)
    setUpdating(true)
    // const projectIds = {
    //   source: 'me-mobile-4410b'
    // }
    await fn_cls.moveToNewFolder(pathViews, cb)
    // await fn_cls.generateAllManifests(database_fns, mainStorage, projectIds)
  }, []);

  return {
    handleGet_prodStorage,
    handleUpdate_globalUrls,
    handleUpdate_profileGlobalUrls,
    handleUpdate_updateImageThumbnails,
    handleUpdate_organizeEventImages,
    handleUpdate_renameStorageImages,
    handleUpdate_testRenameStorageImages,
    handleUpdate_moveFolders
  }
}
